import React from 'react';
import { mediaUrl } from '../../api';
import { applyKitchenEodDiscount } from '../../lib/kitchenEodDiscount';

// A compact menu tile for the counter grid. The entire tile is the tap
// target, photo dominates the top half, and name + price are the only
// text a busy counter operator reads at a glance. Quantity lives on the
// cart, not on the tile.

export default function PosTile({ item, onClick, eodOn = false, closed = false }) {
  const soldOut = !!item.sold_out;
  const blocked = soldOut || closed;
  const hasModifiers = item.modifier_groups && item.modifier_groups.length > 0;
  const hasStockOptions = hasModifiers && item.modifier_groups.some((g) => g.track_stock);
  const itemStock = item.stock_quantity !== null && item.stock_quantity !== undefined
    ? item.stock_quantity
    : null;

  let stockLine = null;
  if (soldOut) {
    stockLine = <span className="pos-tile-stock pos-tile-stock-sold">Sold out</span>;
  } else if (closed) {
    stockLine = <span className="pos-tile-stock pos-tile-stock-closed">Closed</span>;
  } else if (hasStockOptions) {
    stockLine = <span className="pos-tile-stock pos-tile-stock-perOption">Per-option stock</span>;
  } else if (itemStock !== null) {
    const cls = itemStock <= 5
      ? 'pos-tile-stock-low'
      : itemStock <= 20
        ? 'pos-tile-stock-mid'
        : 'pos-tile-stock-ok';
    stockLine = <span className={`pos-tile-stock ${cls}`}>{itemStock} in stock</span>;
  }

  return (
    <button
      type="button"
      className={`pos-tile${blocked ? ' pos-tile-soldout' : ''}`}
      onClick={onClick}
      disabled={blocked}
      aria-disabled={blocked}
    >
      <div className="pos-tile-img-wrap">
        {soldOut && <div className="pos-tile-soldout-ribbon">SOLD OUT</div>}
        {!soldOut && closed && <div className="pos-tile-soldout-ribbon pos-tile-closed-ribbon">CLOSED</div>}
        {item.image_url ? (
          <img
            className="pos-tile-img"
            src={mediaUrl(item.image_url)}
            alt={item.name}
            decoding="async"
          />
        ) : (
          <div className="pos-tile-noimg">{item.name}</div>
        )}
      </div>
      <div className="pos-tile-body">
        <h3 className="pos-tile-name">{item.name}</h3>
        <div className="pos-tile-footer">
          {stockLine}
          <div className="pos-tile-price">
            {item.variable_price ? 'Any $' : (() => {
              const listPrice = Number(item.price);
              const salePrice = applyKitchenEodDiscount(listPrice, item, eodOn);
              if (eodOn && salePrice < listPrice) {
                return (
                  <>
                    <span className="pos-tile-price-was">${listPrice.toFixed(2)}</span>
                    ${salePrice.toFixed(2)}
                  </>
                );
              }
              return `$${listPrice.toFixed(2)}`;
            })()}
            {hasModifiers && !item.variable_price && <span className="pos-tile-price-from"> +</span>}
          </div>
        </div>
      </div>
    </button>
  );
}
